import { z } from 'zod';

/**
 * §10.3 — Handling time ayarları.
 *
 * ⚠️ Bu değerler Amazon'a bildirilen "kargoya verme süresi"ni belirler.
 * Fazla düşük söylemek geç gönderim ve hesap sağlığı kaybı; fazla yüksek
 * söylemek satış kaybı demek. Bu yüzden sınırlar dar tutuluyor.
 */
export const handlingTimeSettingsSchema = z
  .object({
    /** Deponun işleme süresi. */
    warehouseProcessingDays: z.number().int().min(0).max(30).default(2),
    /** Güvenlik payı. */
    bufferDays: z.number().int().min(0).max(30).default(1),
    /** Hiçbir kaynak yoksa tedarik süresi. */
    defaultSupplierDays: z.number().int().min(0).max(60).default(5),
    minHandlingDays: z.number().int().min(0).max(30).default(3),
    /** Amazon üst sınırı 30 gün; aşmıyoruz. */
    maxHandlingDays: z.number().int().min(1).max(30).default(25),
    weekendAware: z.boolean().default(true),
    useScrapedDeliveryEstimate: z.boolean().default(false),
    roundUpToBusinessDays: z.boolean().default(true),
    /** §10.4 — tek seferde bundan fazla artışta kullanıcı onayı. */
    maxIncreasePerPushDays: z.number().int().min(1).max(10).default(2),
  })
  .refine((s) => s.maxHandlingDays >= s.minHandlingDays, {
    message: 'En yüksek handling time, en düşükten küçük olamaz',
    path: ['maxHandlingDays'],
  });

export type HandlingTimeSettingsInput = z.input<typeof handlingTimeSettingsSchema>;

/** §10.4 — "kaç ürün, ne kadar değişecek" simülasyonu. */
export const handlingTimeSimulateSchema = z.object({
  /** Kaydedilmemiş ayarlarla dene (canlı önizleme). */
  settings: handlingTimeSettingsSchema.optional(),
  /** Kaç ürün incelensin. */
  limit: z.number().int().min(1).max(100_000).default(5_000),
});
export type HandlingTimeSimulateInput = z.input<typeof handlingTimeSimulateSchema>;

/** §10.2 — kaynak etiketleri; kullanıcı ham enum görmemeli (§19). */
export const HANDLING_TIME_SOURCE_LABELS: Record<string, string> = {
  SCRAPE: 'Ürün sayfasından okundu',
  PRIME_ESTIMATE: 'Prime / FBA kestirimi',
  SELLER_STATS: 'Satıcı geçmişi',
  CATEGORY_AVG: 'Kategori ortalaması',
  DEFAULT: 'Varsayılan',
  MANUAL: 'Elle girildi',
  AUTO: 'Otomatik',
};

export const HANDLING_TIME_SOURCE_TONE: Record<string, 'success' | 'accent' | 'neutral' | 'warning'> =
  {
    SCRAPE: 'success',
    PRIME_ESTIMATE: 'accent',
    SELLER_STATS: 'accent',
    CATEGORY_AVG: 'neutral',
    DEFAULT: 'warning',
    MANUAL: 'accent',
    AUTO: 'neutral',
  };
